export default __webpack_public_path__ + "static/069-a8ece0225ffd3cd5784c30e440ac0ce2.jpg";